// store/useOneToManySlotStore.js
import { create } from 'zustand';

const useOneToManySlotStore = create((set) => ({
    oneToManySlot: null, // stores one slot
    setOneToManySlot: (slotData) => set({ oneToManySlot: slotData }), // set correctly
    removeOneToManySlot: () => set({ oneToManySlot: null }), // reset correctly
}));

export default useOneToManySlotStore;
